// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
export { BrandRibbonEditable } from './BrandRibbon';
export { BrandRibbonMock, featureFlagMock } from './__mock__/BrandRibbon.mock';
